import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, withHandlers, withProps } from 'recompose';

import { buyGiftCard } from '../actions';
import WithShop from '../../hoc/WithShop';
import withGiftCardLink from '../hoc/withGiftCardLink';
import WithShopCurrency from '../../hoc/WithShopCurrency';
import withGiftCardAmount from '../hoc/withGiftCardAmount';
import withGiftCardBarber from '../hoc/withGiftCardBarber';
import { getIsFormValid, getUser } from '../../reservation/selectors';

export default compose(
  WithShopCurrency,
  WithShop,
  withGiftCardAmount,
  withGiftCardBarber,
  withGiftCardLink,
  withRouter,
  connect(
    state => ({
      user: getUser(state),
      formValid: getIsFormValid(state),
    }),
    { buyGiftCard },
  ),
  withProps(props => ({
    paymentEnabled: props.formValid && !!props.shop && props.gcAmount && !!props.gcBarber,
  })),
  withHandlers({
    checkout: props => (token) => {
      const onlyShopRoute = props.link.pathname.split('/').slice(0, 3).join('/');
      let successUrl = `${onlyShopRoute}/${props.gcBarber.route}/${props.gcAmount}/view`;

      if (props.location.query.brand) {
        successUrl = `${successUrl}?brand=${props.location.query.brand}`;
      }

      const data = {
        customer: props.user,
        amount: props.gcAmount,
        barberId: props.gcBarber ? props.gcBarber.id : null,
        paymentToken: token.id,
      };

      props.buyGiftCard(props.shop, data, successUrl);
    },
  }),
);



// WEBPACK FOOTER //
// ./src/app/giftCard/Checkout/CheckoutContainer.js